"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import DateFormat from "@/framework/timeformatter";
import EditJoinedTeam from "@/views/teamItems/components/dialog/EditJoinedTeam.vue";
import API from "@ym-framework/api-utils";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import Question from "@/components/Question.vue";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v8/team/myteamlist")
);
let teamIJoined = class extends Vue {
  constructor() {
    super(...arguments);
    this.formatter = DateFormat;
    this.gridController = _gridController;
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.sort = "created_time,desc";
      yield this.gridController.search();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.sort = "created_time,desc";
      yield this.gridController.search();
    });
  }
  moveout(data) {
    return __async(this, null, function* () {
      try {
        let confirm = yield this.$confirm(
          this.$t("team_management.team_joined.confirm.message", { "team": data.team_name }),
          this.$t("team_management.team_joined.confirm.title"),
          {
            customClass: "confirm-dark",
            confirmButtonText: this.$t(
              "team_management.team_joined.confirm.confirm"
            ),
            cancelButtonText: this.$t(
              "team_management.team_joined.confirm.cancel"
            ),
            confirmButtonClass: "btn-main",
            cancelButtonClass: "btn-dark",
            roundButton: true
          }
        );
        yield API.delete(
          `api://base.auth/api/v1/team/${data.team_id}/members/audit`
        );
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.model.first().message);
        }
      }
    });
  }
  openedit(data) {
    console.log("data", data);
    this._edit_joined_team.open(data);
  }
};
__decorateClass([
  Ref("edit-joined-team")
], teamIJoined.prototype, "_edit_joined_team", 2);
__decorateClass([
  PropSync("refreshKey", { type: String })
], teamIJoined.prototype, "random_key", 2);
teamIJoined = __decorateClass([
  Component({
    components: {
      EditJoinedTeam,
      UiGrid,
      Question
    }
  })
], teamIJoined);
export {
  teamIJoined as default
};
